//
// Dev alarm feed: every response the app receives is watched for the statuses
// fail2ban bans on in production (404 on first hit, 401 after a few), so a
// client of ours tripping one is seen before release. Installed once, dev and
// demo builds only; see "Request rejection, rate limits and bans" in global/docs.
//
const countedStatuses = [401, 404];
const listeners = new Set();
let installed = false;

const emit = (event) => listeners.forEach((listener) => listener(event));

// The DEV answer body carries the reqFail kind and its details
const parseBody = (text) => {
  try {
    const body = JSON.parse(text);
    return { kind: body.kind, details: body.error };
  } catch {
    return {};
  }
};

const install = () => {
  if (installed) return;
  installed = true;

  const { open, send } = XMLHttpRequest.prototype;
  XMLHttpRequest.prototype.open = function pxOpen(method, url, ...rest) {
    this.pxMethod = method;
    this.pxUrl = url;
    return open.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function pxSend(...args) {
    this.addEventListener(
      'loadend',
      () => {
        if (!countedStatuses.includes(this.status)) return;
        const readable = (this.responseType === '') || (this.responseType === 'text');
        emit({
          status: this.status,
          method: this.pxMethod,
          url: this.pxUrl,
          at: new Date(),
          ...(readable ? parseBody(this.responseText) : {}),
        });
      },
    );
    return send.apply(this, args);
  };

  const originalFetch = window.fetch;
  window.fetch = async (input, init) => {
    const res = await originalFetch(input, init);
    if (countedStatuses.includes(res.status)) {
      const text = await res.clone().text().catch(() => '');
      emit({
        status: res.status,
        method: init?.method ?? 'GET',
        url: (typeof input === 'string') ? input : input.url,
        at: new Date(),
        ...parseBody(text),
      });
    }
    return res;
  };
};

const watchCountedResponses = (listener) => {
  install();
  listeners.add(listener);

  return () => listeners.delete(listener);
};

export default watchCountedResponses;
